// Polyfills
// import 'core-js/es6';
// Added parts of es6 which are necessary for your project or your browser support requirements.
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-map';
import 'core-js/es6/weak-set';
import 'core-js/es6/typed';
import 'core-js/es6/reflect';

// see issue https://github.com/AngularClass/angular2-webpack-starter/issues/709
// import 'core-js/es6/promise';

import 'reflect-metadata';
import 'zone.js/dist/zone';

// Typescript emit helpers polyfill
import 'ts-helpers';

if (process.env.ENV === 'build') {
    // Production

} else {
    // Development

    Error['stackTraceLimit'] = Infinity;

     /* tslint:disable no-var-requires */
    require('zone.js/dist/long-stack-trace-zone');
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/polyfills.ts